import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import * as T from '../../../components/Typography';
import { Row, Col } from '../../../components/Grid';
import moment from 'moment';
import { Learners } from '../../../api-calls';
import Loading from '../../../components/Loading';
import ManualCard from '../../../components/ManualCard';
import * as S from './style';

const AchievedDate = ({ mId, milestones }) => {
  const milestone = milestones?.find((m) => m.milestoneId === mId);

  return (
    <T.P color="neutral90" mt="3" ml="5" mr="5" mb="4">
      {milestone
        ? `Achieved on ${moment(milestone?.createdAt).format('DD MMMM YYYY')}`
        : 'N/A'}
    </T.P>
  );
};

const LearnerMilestonesReached = () => {
  const { learnerId } = useParams();
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');
  const [stats, setStats] = useState([]);

  useEffect(() => {
    let mount = true;
    async function fetchData() {
      setLoading(true);
      const { data, error } = await Learners.getLearnerStats({ learnerId });
      if (mount) {
        if (!error) {
          setStats(data.milestonesReached);
        } else {
          setErr(error.message);
        }
        setLoading(false);
      }
    }
    fetchData();
    return () => {
      mount = false;
    };
  }, [learnerId]);

  if (loading) return <Loading />;
  return (
    <div>
      <T.H2 mb="5">Milestones reached</T.H2>
      {stats?.length !== 0 ? (
        [
          [1, 2, 3],
          [4, 5, 6],
          [7, 8, 9],
          [10, 11, 12],
          [13, 14, 15],
        ].map((manual, index) => {
          return (
            <S.Wrapper>
              <ManualCard manualNumber={index + 1} />
              <S.OuterWrapper>
                {manual.map((e, milestoneIndex) => (
                  <S.MilestoneWrapper>
                    <T.P weight="bold" mt="4" ml="5">
                      Milestone {e}
                    </T.P>
                    <AchievedDate mId={e} milestones={stats} />
                  </S.MilestoneWrapper>
                ))}
              </S.OuterWrapper>
            </S.Wrapper>
          );
        })
      ) : (
        <Row>
          <Col w={[4, 9, 9]} mb="5">
            <T.P>None of the milestones reached yet.</T.P>
          </Col>
        </Row>
      )}
      {err && (
        <Row>
          <Col w={[4, 7, 7]}>
            <T.P>{err.message}</T.P>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default LearnerMilestonesReached;
